<div class="row ">
  <div class="col text-center">
      <input type="file" style="text-align:center" ngFileSelect [options]='options' (onUpload)="handleUpload($event)" (beforeUpload)="beforeUpload($event)">
  </div>
  
</div>
<div class="row" style="margin-top:10px">
  <div class="col">
    <button *ngIf="filename" class="btn btn-success3 btn-block" (click)="UploadComplete()" >Upload</button>
  </div>
  <div class="col">
    <button class="btn btn-success btn-block" md-dialog-close>Cancel</button>
  </div>
</div>